import axios from 'axios'
import {serialize} from '../../../core/_util'
export const API_URL = process.env.REACT_APP_BASE_API_URL
const ADD_PEOPLE = `${API_URL}/company-page`
const GET_ALL_PEOPLE = `${API_URL}/company-page`
const DELETE_PEOPLE = `${API_URL}/company-page`
const UPDATE_PEOPLE = `${API_URL}/company-page`
const GET_SINGLE_COMAPNY_PEOPLE = `${API_URL}/company-page`
const ADD_INVESTMENT = `${API_URL}/company-page`
const GET_ALL_INVESTMENT = `${API_URL}/company-page`
const DELETE_INVESTMENT = `${API_URL}/company-page`
const UPDATE_INVESTMENT = `${API_URL}/company-page`
const GET_SINGLE_COMAPNY_INVESTMENT = `${API_URL}/company-page`
const ADD_INVESTORS = `${API_URL}/company-page`
const GET_ALL_INVESTORS = `${API_URL}/company-page`
const DELETE_INVESTORS = `${API_URL}/company-page`
const UPDATE_INVESTORS = `${API_URL}/company-page`
const GET_SINGLE_COMAPNY_INVESTORS = `${API_URL}/company-page`
const ADD_BOARD_ADVISORS = `${API_URL}/company-page`
const GET_ALL_BOARD_ADVISORS = `${API_URL}/company-page`
const DELETE_BOARD_ADVISORS = `${API_URL}/company-page`
const UPDATE_BOARD_ADVISORS = `${API_URL}/company-page`
const GET_SINGLE_COMAPNY_BOARD_ADVISORS = `${API_URL}/company-page`
const GET_COMPANY_DATA = `${API_URL}/company`
const UPDATE_COMPANY_PUBLISH_STATUS = `${API_URL}/company-page`
const UPDATE_INDUSTRY_FOCUS = `${API_URL}/company-page`
const GET_INDUSTRY_FOCUS = `${API_URL}/company-page`
const GET_PUBLIC_COMPANY_PAGE = `${API_URL}/company-page`

export const addPeople = (data: any, companyId: number) => {
  return axios.post(`${ADD_PEOPLE}/${companyId}/people`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllPeople = (
  companyId: number,
  searchInvestorUser?: string | undefined,
  sortByUser?: string,
  sortOrderUser?: string
) => {
  const object = {
    search: searchInvestorUser,
    sort_by: sortByUser,
    sort_order: sortOrderUser,
  }
  return axios.get(`${GET_ALL_PEOPLE}/${companyId}/people?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deletePeople = (companyPeopleId: number) => {
  return axios.delete(`${DELETE_PEOPLE}/people/${companyPeopleId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updatePeople = (data: any, companyPeopleId: number) => {
  return axios.put(`${UPDATE_PEOPLE}/people/${companyPeopleId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getSingleCompanyPeople = (companyPeopleId: number) => {
  return axios.get(`${GET_SINGLE_COMAPNY_PEOPLE}/people/${companyPeopleId}`, {
    validateStatus(status) {
      return true
    },
  })
}

//Investments

export const addInvestment = (data: any, companyId: number) => {
  return axios.post(`${ADD_INVESTMENT}/${companyId}/investments`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateInvestment = (data: any, companyInvestmentId: number) => {
  return axios.put(`${UPDATE_INVESTMENT}/investments/${companyInvestmentId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getSingleCompanyInvestment = (companyInvestmentId: number) => {
  return axios.get(`${GET_SINGLE_COMAPNY_INVESTMENT}/investments/${companyInvestmentId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteInvestment = (companyInvestmentId: number) => {
  return axios.delete(`${DELETE_INVESTMENT}/investments/${companyInvestmentId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllInvestment = (
  companyId: number,
  sortInvestmentBy?: string,
  sortInvestmentOrder?: string
) => {
  const object = {
    sort_by: sortInvestmentBy,
    sort_order: sortInvestmentOrder,
  }
  return axios.get(`${GET_ALL_INVESTMENT}/${companyId}/investments?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

//Investors

export const addInvestors = (data: any, companyId: number) => {
  return axios.post(`${ADD_INVESTORS}/${companyId}/investors`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateInvestors = (data: any, companyInvestorsId: number) => {
  return axios.put(`${UPDATE_INVESTORS}/investors/${companyInvestorsId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getSingleCompanyInvestors = (companyInvestorsId: number) => {
  return axios.get(`${GET_SINGLE_COMAPNY_INVESTORS}/investors/${companyInvestorsId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteInvestors = (companyInvestorsId: number) => {
  return axios.delete(`${DELETE_INVESTORS}/investors/${companyInvestorsId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllInvestors = (
  companyId: number,
  sortInvestorsBy?: string,
  sortInvestorsOrder?: string
) => {
  const object = {
    sort_by: sortInvestorsBy,
    sort_order: sortInvestorsOrder,
  }
  return axios.get(`${GET_ALL_INVESTORS}/${companyId}/investors?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

//board members

export const addBoardAdvisors = (data: any, companyId: number) => {
  return axios.post(`${ADD_BOARD_ADVISORS}/${companyId}/board-advisors`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateBoardAdvisors = (data: any, companyBoardAdvisorsId: number) => {
  return axios.put(`${UPDATE_BOARD_ADVISORS}/board-advisors/${companyBoardAdvisorsId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getSingleCompanyBoardAdvisors = (companyBoardAdvisorsId: number) => {
  return axios.get(
    `${GET_SINGLE_COMAPNY_BOARD_ADVISORS}/board-advisors/${companyBoardAdvisorsId}`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteBoardAdvisors = (companyBoardAdvisorsId: number) => {
  return axios.delete(`${DELETE_BOARD_ADVISORS}/board-advisors/${companyBoardAdvisorsId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllBoardAdvisors = (companyId: number) => {
  return axios.get(`${GET_ALL_BOARD_ADVISORS}/${companyId}/board-advisors`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getCompanyData = (companyId: number) => {
  return axios.get(`${GET_COMPANY_DATA}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateCompanyPublishStatus = (companyId: number, payload: {published: boolean}) => {
  return axios.put(`${UPDATE_COMPANY_PUBLISH_STATUS}/${companyId}/published`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateIndustryFocus = (companyId: number, payload: {industries: string[]}) => {
  return axios.put(`${UPDATE_INDUSTRY_FOCUS}/${companyId}/industry-focus`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const getIndustryFocus = (companyId: number) => {
  return axios.get(`${GET_INDUSTRY_FOCUS}/${companyId}/industry-focus`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getPublicCompanyPage = (slug: string, payload: any) => {
  return axios.post(`${GET_PUBLIC_COMPANY_PAGE}/public/${slug}`, payload, {
    validateStatus(status) {
      return true
    },
  })
}
